import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTypeError: {
		id: 'issue-field-statistics.single-select-chart-container.chart-type-error',
		defaultMessage: ' Invalid chart type. Please select a valid chart type from the options below.',
		description: 'Error message we display when the chart type is not supported',
	},
	chartTypeSelectLabel: {
		id: 'issue-field-statistics.single-select-chart-container.chart-type-select-label',
		defaultMessage: 'Chart type',
		description: 'Label for the chart type select dropdown',
	},
	donutChartLabel: {
		id: 'issue-field-statistics.single-select-chart-container.donut-chart-label',
		defaultMessage: 'Donut chart',
		description: 'Label for the donut chart in the select chart dropdown',
	},
	horizontalBarChartLabel: {
		id: 'issue-field-statistics.single-select-chart-container.horizontal-bar-chart-label',
		defaultMessage: 'Horizontal bar chart',
		description: 'Label for the horizontal bar chart in the select chart dropdown',
	},
});
